export const mockCategories = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', description: '国内外热门电影大片' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line', description: '热门电视剧全集' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '热门综艺节目' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line', description: '日本动漫与国产动画' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '精品纪录片' },
];

export const mockVideos = [
  {
    id: 'v1',
    title: '星际穿越',
    category: 'dianying',
    rating: 9.4,
    description: '诺兰科幻神作，穿越虫洞寻找人类新家园',
    image: 'https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%2C%20astronaut%20floating%20near%20wormhole%2C%20deep%20space%20background%20with%20stars%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20and%20dark%20tones%2C%20minimalist%20movie%20poster%20design%2C%20no%20text%2C%20clean%20background&width=600&height=800&seq=movie-interstellar&orientation=portrait',
    views: '2.3亿',
    year: '2014',
  },
  {
    id: 'v2',
    title: '流浪地球2',
    category: 'dianying',
    rating: 9.2,
    description: '中国科幻里程碑，人类命运共同体的壮丽史诗',
    image: 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%20movie%20poster%20style%2C%20massive%20planet%20engines%20on%20Earth%20surface%2C%20futuristic%20space%20station%2C%20dramatic%20orange%20and%20blue%20color%20scheme%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20minimalist%20design%2C%20clean%20background%2C%20no%20text&width=600&height=800&seq=movie-wandering-earth&orientation=portrait',
    views: '5.8亿',
    year: '2023',
  },
  {
    id: 'v3',
    title: '狂飙',
    category: 'dianshiju',
    rating: 9.5,
    description: '扫黑除恶题材剧王，张译张颂文演技巅峰对决',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20style%2C%20two%20men%20in%20tense%20standoff%2C%20urban%20night%20cityscape%20background%2C%20dramatic%20contrast%20lighting%2C%20dark%20and%20warm%20tones%2C%20cinematic%20composition%2C%20minimalist%20poster%20design%2C%20no%20text&width=600&height=800&seq=drama-kuangbiao&orientation=portrait',
    views: '12.5亿',
    year: '2023',
  },
  {
    id: 'v4',
    title: '繁花',
    category: 'dianshiju',
    rating: 9.3,
    description: '王家卫首部电视剧，上海90年代商海传奇',
    image: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20nostalgic%20drama%20poster%2C%20elegant%20woman%20in%20cheongsam%2C%20neon%20lights%20of%20old%20Shanghai%20bund%2C%20warm%20golden%20retro%20tones%2C%20Wong%20Kar%20Wai%20aesthetic%2C%20cinematic%20composition%2C%20no%20text&width=600&height=800&seq=drama-fanhua&orientation=portrait',
    views: '8.2亿',
    year: '2024',
  },
  {
    id: 'v5',
    title: '乘风破浪的姐姐',
    category: 'zongyi',
    rating: 8.9,
    description: '30+姐姐逆龄成团，见证女性力量的璀璨绽放',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20confident%20women%20on%20stage%2C%20spotlight%20and%20stage%20effects%2C%20vibrant%20warm%20colors%2C%20fashionable%20outfits%2C%20glamorous%20performance%20scene%2C%20clean%20poster%20design%2C%20no%20text&width=600&height=800&seq=variety-sisters&orientation=portrait',
    views: '4.1亿',
    year: '2024',
  },
  {
    id: 'v6',
    title: '间谍过家家',
    category: 'dongman',
    rating: 9.1,
    description: '超能力少女与间谍父亲的温馨家庭喜剧',
    image: 'https://readdy.ai/api/search-image?query=Spy%20x%20Family%20anime%20poster%20style%2C%20a%20family%20of%20three%20with%20mysterious%20expressions%2C%20pastel%20warm%20color%20palette%2C%20playful%20elegant%20composition%2C%20clean%20anime%20art%20style%2C%20soft%20lighting%2C%20no%20text&width=600&height=800&seq=anime-spy-family&orientation=portrait',
    views: '3.7亿',
    year: '2023',
  },
  {
    id: 'v7',
    title: '蓝色星球II',
    category: 'jilupian',
    rating: 9.8,
    description: 'BBC史诗级海洋纪录片，探索深海未知世界',
    image: 'https://readdy.ai/api/search-image?query=Blue%20Planet%20documentary%20poster%20style%2C%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20whale%20silhouette%20in%20deep%20blue%20water%2C%20majestic%20marine%20life%2C%20dramatic%20underwater%20lighting%2C%20minimalist%20design%2C%20no%20text&width=600&height=800&seq=docu-blue-planet&orientation=portrait',
    views: '1.9亿',
    year: '2017',
  },
  {
    id: 'v8',
    title: '庆余年第二季',
    category: 'dianshiju',
    rating: 9.2,
    description: '范闲归来，权谋升级，古装剧巅峰之作',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20handsome%20man%20in%20ancient%20Chinese%20robe%2C%20traditional%20Chinese%20palace%20architecture%20background%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20cinematic%20composition%2C%20no%20text&width=600&height=800&seq=drama-qingyunian&orientation=portrait',
    views: '10.1亿',
    year: '2024',
  },
  {
    id: 'v9',
    title: '奥本海默',
    category: 'dianying',
    rating: 9.3,
    description: '诺兰执导原子弹之父传记，IMAX视觉盛宴',
    image: 'https://readdy.ai/api/search-image?query=Oppenheimer%20movie%20poster%20style%2C%20mushroom%20cloud%20silhouette%20with%20intense%20orange%20and%20black%20contrast%2C%20dramatic%20explosion%20lighting%2C%20minimalist%20poster%20composition%2C%20cinematic%20atmosphere%2C%20no%20text&width=600&height=800&seq=movie-oppenheimer&orientation=portrait',
    views: '3.2亿',
    year: '2023',
  },
  {
    id: 'v10',
    title: '地球脉动III',
    category: 'jilupian',
    rating: 9.9,
    description: 'BBC自然纪录片新标杆，4K超清震撼视觉',
    image: 'https://readdy.ai/api/search-image?query=Planet%20Earth%20documentary%20poster%20style%2C%20aerial%20view%20of%20lush%20rainforest%20with%20sunlight%20rays%2C%20diverse%20wildlife%20silhouettes%2C%20vibrant%20green%20and%20golden%20tones%2C%20epic%20natural%20landscape%2C%20no%20text&width=600&height=800&seq=docu-planet-earth&orientation=portrait',
    views: '2.6亿',
    year: '2023',
  },
  {
    id: 'v11',
    title: '鬼灭之刃 锻刀村篇',
    category: 'dongman',
    rating: 9.0,
    description: '炭治郎新篇章，锻刀村热血战斗再开',
    image: 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20anime%20poster%20style%2C%20warrior%20with%20flaming%20sword%20in%20dynamic%20pose%2C%20traditional%20Japanese%20village%20background%2C%20vibrant%20warm%20orange%20and%20red%20tones%2C%20action%20composition%2C%20no%20text&width=600&height=800&seq=anime-demon-slayer&orientation=portrait',
    views: '5.3亿',
    year: '2023',
  },
  {
    id: 'v12',
    title: '这！就是街舞',
    category: 'zongyi',
    rating: 8.7,
    description: '顶尖舞者巅峰对决，燃炸舞台热血沸腾',
    image: 'https://readdy.ai/api/search-image?query=Street%20dance%20competition%20show%20poster%2C%20dancer%20in%20dynamic%20breakdance%20move%2C%20stage%20spotlights%20with%20colorful%20effects%2C%20urban%20vibrant%20energy%2C%20warm%20neon%20tones%2C%20no%20text&width=600&height=800&seq=variety-dance&orientation=portrait',
    views: '6.5亿',
    year: '2024',
  },
];